import React from "react";
import { OWNER } from "../mock/mock";
import { MapPin } from "lucide-react";

export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-14 items-center">
        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-forge-gold mb-3">About Forge Stays</div>
          <h2 className="font-serif text-4xl md:text-5xl text-forge-navy leading-tight">Comfortable places, all across Anglesey</h2>
          <hr className="forge-divider !mx-0" />
          <p className="text-forge-navy/75 leading-relaxed">
            Forge Stays is a locally-owned collection of comfortable, well-designed places to stay
            around Anglesey. Whether you're here for a project at RAF Valley, a stopover through
            Holyhead port, a family holiday on the coast or somewhere in between — we've got a
            welcoming base for you.
          </p>
          <p className="text-forge-navy/75 leading-relaxed mt-4">
            Our <strong>five entire three-bedroom en-suite townhouses on Cymyran Terrace</strong> and
            our <strong>Newry Street townhouse in Holyhead</strong> are all bookable now. Our
            nine-bedroom <strong>Lodge at Hotel Cymyran</strong> opens in around a month, with our
            boutique hotel rooms to follow. Every stay comes with the same standards — comfort,
            cleanliness, reliable Wi-Fi and a warm welcome.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-forge-cream flex items-center justify-center shrink-0">
                <MapPin size={16} className="text-forge-navy" />
              </div>
              <div>
                <div className="text-xs tracking-[0.2em] uppercase text-forge-navy/60">Available Now</div>
                <div className="font-serif text-forge-navy">Cymyran Terrace</div>
                <div className="text-xs text-forge-navy/70">5 × 3-bed en-suite townhouses · Valley</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-forge-cream flex items-center justify-center shrink-0">
                <MapPin size={16} className="text-forge-navy" />
              </div>
              <div>
                <div className="text-xs tracking-[0.2em] uppercase text-forge-navy/60">Available Now</div>
                <div className="font-serif text-forge-navy">Newry Street</div>
                <div className="text-xs text-forge-navy/70">Townhouse · Holyhead</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="aspect-[3/4] overflow-hidden bg-forge-off">
            <img src={OWNER.newry_bedroom2} alt="Newry Street bedroom" className="w-full h-full object-cover" />
          </div>
          <div className="aspect-[3/4] overflow-hidden bg-forge-off mt-8">
            <img src={OWNER.cymyran_living1} alt="Hotel Cymyran living" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
}
